import "babel-polyfill";
import "bootstrap";
import "@fortawesome/fontawesome-free/css/all.css";
import "../../css/core/reset.scss";
import "../../css/core/app.scss";

// Global app Javascript
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes";

// import Swiper bundle with all modules installed
import {
	Swiper,
	Navigation,
	Pagination,
	Scrollbar,
	Autoplay,
} from "swiper/swiper.esm.js";
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

// init Swiper:
const swiper = new Swiper();

// UWP custom helpers
import Minicart from "../minicart.js";
import Product from "../product.js";
import User from "../user.js";
import Cart from "../cart.js";
import Lookbook from "../lookbook.js";
import Variants from "../variants.js";

import "../megamenu.js";
import { gorgias } from "../gorgias";

window.addEventListener("DOMContentLoaded", function () {
	const heroSwiper = new Swiper(".hero-swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		simulateTouch: true,
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	});

	const collectionsSwiper = new Swiper(".collections-swiper", {
		slidesPerView: 2.5,
		spaceBetween: 15,
		simulateTouch: true,
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			type: "bullets",
		},
		scrollbar: {
			el: ".swiper-scrollbar",
		},
		breakpoints: {
			// when window width is >= 600px
			600: {
				slidesPerView: 5,
			},
		},
	});

	/* Use the session storage current image created on line 310 of product-form.liquid to select the current variant featured image */

	const imageUpdate = () => {
		document.addEventListener("click", (e) => {
			if (e.target.matches("[data-varimage]")) {
				setTimeout(() => {
					let currentImgId = sessionStorage.getItem("currentImg");
					let currentImg = document.querySelector(
						`[data-device-image="${currentImgId}"]`
					);
					let currentImgIndex =
						currentImg.closest("div").dataset.swiperSlideIndex;
					let index = parseInt(currentImgIndex) + 1;
					productImagesSwiper.slideTo(index, 250);
				}, 250);
			}
		});
	};

	const productImagesSwiper = new Swiper(".product-images-swiper", {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		on: {
			init: function () {
				imageUpdate();
			},
		},
	});

	var simpleHeroSwiper = document.querySelector(".simple-hero-swiper");
	if (simpleHeroSwiper) {
		var autoplay = simpleHeroSwiper.dataset.autoplay === "true" ? true : false;
		var slideInterval = Number(simpleHeroSwiper.dataset.slideInterval) * 1000;
		simpleHeroSwiper = new Swiper(".simple-hero-swiper", {
			slidesPerView: 1,
			spaceBetween: 0,
			simulateTouch: true,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},
			autoplay: {
				delay: autoplay ? slideInterval : 99999999,
				disableOnInteraction: false,
			},
		});
	}

	var imageSwiper = document.querySelector(".image-swiper");
	if (imageSwiper) {
		imageSwiper = new Swiper(".image-swiper", {
			slidesPerView: 2.2,
			spaceBetween: 5,
			simulateTouch: true,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			scrollbar: {
				el: ".swiper-scrollbar",
				dragSize: 893,
			},
			breakpoints: {
				// when window width is >= 600px
				600: {
					slidesPerView: 4.2,
					spaceBetween: 10,
				},
			},
		});
	}

	var productSwiper = document.querySelector(".products-swiper");
	if (productSwiper) {
		productSwiper = new Swiper(".products-swiper", {
			slidesPerView: 2,
			spaceBetween: 5,
			simulateTouch: true,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			scrollbar: {
				el: ".swiper-scrollbar",
				dragSize: 893,
			},
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				clickable: true,
			},
			breakpoints: {
				// when window width is >= 600px
				600: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
			},
		});
	}

	gorgias();
});
